import { PRDManager, PRD } from '../../core/prd-manager.js';
import { PRDGenerator } from '../../core/prd-generator.js';

export class PRDService {
  private prdManager: PRDManager;
  private prdGenerator: PRDGenerator;

  constructor() {
    this.prdManager = new PRDManager();
    this.prdGenerator = new PRDGenerator();
  }

  async list(): Promise<PRD[]> {
    return await this.prdManager.listPRDs();
  }

  async get(id: string): Promise<PRD | null> {
    return await this.prdManager.getPRD(id);
  }

  async create(prdData: any): Promise<PRD> {
    // 使用 PRDGenerator 生成 PRD
    const result = await this.prdGenerator.generate({
      title: prdData.title,
      description: prdData.description || prdData.overview || '',
      author: prdData.author,
      version: prdData.version,
      createTasks: true,
    });
    
    // 保存 PRD
    const path = await this.prdGenerator.savePRD(result.id, result.content);
    
    // 获取保存的 PRD
    const prd = await this.prdManager.getPRD(result.id);
    if (!prd) {
      throw new Error('Failed to create PRD');
    }
    
    return prd;
  }

  async update(id: string, updates: any): Promise<PRD> {
    const prd = await this.prdManager.updatePRDMetadata(id, updates);
    if (!prd) {
      throw new Error('PRD not found');
    }
    return prd;
  }

  async delete(id: string): Promise<void> {
    // TODO: 实现删除功能
    throw new Error('Delete not implemented');
  }

  async updateLinkedTasks(id: string, taskIds: string[]): Promise<void> {
    await this.prdManager.updatePRDMetadata(id, { taskIds });
  }

  async exportToMarkdown(id: string): Promise<string> {
    const prd = await this.prdManager.getPRD(id);
    if (!prd) {
      throw new Error('PRD not found');
    }
    return prd.content;
  }
  
  // 新增方法
  async getStats(id: string) {
    return await this.prdManager.getPRDStats(id);
  }
  
  async generateReport(id: string): Promise<string> {
    return await this.prdManager.generatePRDReport(id);
  }
  
  async updateProgress(id: string): Promise<void> {
    await this.prdManager.updatePRDProgress(id);
  }
}